import { Grid, Typography } from "@mui/material";
import { motion } from "motion/react";

const ItemCard = ({
  imgSrc,
  name
}: {
  imgSrc: string;
  name: string;
}) => (
  <motion.button
  whileHover={{ scale: 1.1 }}
  whileTap={{ scale: 0.95 }}
  >
    <div style={{ width: "100%", aspectRatio: "3 / 4"}}>
      <img
        src={imgSrc}
        alt={name}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </div>
  </motion.button>
);

export default ItemCard;